import { useProducts } from './use-products';
import { Button } from '@ui/buttons/button';
import { Trans } from '@ui/i18n/trans';
import { ForumIcon } from '@ui/icons/material/Forum';
import { Navbar } from '../../ui/navigation/navbar/navbar';
import { Link } from 'react-router';
import { Footer } from '../../ui/footer/footer';
import { Fragment, useState } from 'react';
import { UpsellBillingCycle } from './find-best-price';
import { BillingCycleRadio } from './billing-cycle-radio';
import { StaticPageTitle } from '../../seo/static-page-title';
import { PricingTable } from '@common/billing/pricing-table/pricing-table';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export function PricingPage() {
  const query = useProducts('pricingPage');
  const [selectedCycle, setSelectedCycle] = useState<UpsellBillingCycle>('yearly');

  useEffect(() => {
    AOS.init({
      duration: 1500
    });
  }, []);

  return (
    <Fragment>
      <StaticPageTitle>
        <Trans message="Pricing" />
      </StaticPageTitle>
      <Navbar
        color="bg"
        darkModeColor="transparent"
        border="border-b"
        menuPosition="pricing-table-page"
      />
      <div className="landing-container">
        <h1 className="Plans_heads" data-aos="fade-left">
          <Trans message="Individual plans" />
        </h1>

        {/* <BillingCycleRadio

          products={query.data?.products}
          selectedCycle={selectedCycle}
          onChange={setSelectedCycle}
          className="mb-20 flex justify-center radio_bts"
          size="lg"
        /> */}
      </div>

      <div className='price_bg'>
        <div className='landing-container'>
          <PricingTable
            selectedCycle={selectedCycle}
            productLoader="pricingPage"
          />
          {/* <ContactSection /> */}
        </div>
      </div>

      <LifeTime />

      <TimePlan />

      <Accounts />

      <Footer className="container mx-auto flex-shrink-0 px-24" />
    </Fragment>
  );
}

function LifeTime() {
  return (
    <>
      {/* Staer-section */}



      <section className='life_time'>
        <div className='landing-container'>
          <div className='time_head'>
            <h3 data-aos="fade-right">Can I, later on upgrade to large Lifetime Plan?</h3>
            <p data-aos="fade-left">Prices are final. No setup fees or other hidden charges!</p>
          </div>
          <div className='row pt-sm-5 pt-4'>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/fam_1.png" alt="" />
                </div>
                <h3>pCloud for Family</h3>
                <p>Share your space with up to four family members.</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/fam_2.png" alt="" />
                </div>
                <h3>pCloud Business</h3>
                <p>Organize your team and collaborate on all business projects.</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-4 mb-4'>
              <div className='family_contents' data-aos="zoom-in">
                <div className='family_img'>
                  <img src="images/homepage/fam_3.png" alt="" />
                </div>
                <h3>Link traffic</h3>
                <p>Get additional traffic for your shared links.</p>
              </div>
            </div>
          </div>
          <div className='wants_text'>
            <p>Want to explore pCloud? Go for our monthly plans or  Try for Free</p>
          </div>
        </div>
      </section>

      {/* End section */}
    </>
  )
}

function TimePlan() {

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    loop: true,
    autoplay: false,
    slidesToShow: 3, // Adjust this based on your layout
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      {/* start scetion */}
      <section className='one_time_plan'>
        <div className='landing-container'>
          <div className="privileges_head">
            <h1 data-aos="fade-left">Onetime Features included with all plans</h1>
          </div>



          <Slider {...settings}>
            <div className='collapse_contents'>
              <div className='collapse_img'>
                <img src="images/homepage/collaps_1.png" alt="Brand 1" />
              </div>
              <h2>Collaboration</h2>
              <div className='dtt_width'>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Invite users to shared folders</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Get detailed stats for your links</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
              </div>
            </div>
            <div className='collapse_contents'>
              <div className='collapse_img'>
                <img src="images/homepage/collaps_1.png" alt="Brand 1" />
              </div>
              <h2>Collaboration</h2>
              <div className='dtt_width'>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Invite users to shared folders</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Get detailed stats for your links</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
              </div>
            </div>
            <div className='collapse_contents'>
              <div className='collapse_img'>
                <img src="images/homepage/collaps_1.png" alt="Brand 1" />
              </div>
              <h2>Collaboration</h2>
              <div className='dtt_width'>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Invite users to shared folders</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Get detailed stats for your links</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
              </div>
            </div>
            <div className='collapse_contents'>
              <div className='collapse_img'>
                <img src="images/homepage/collaps_1.png" alt="Brand 1" />
              </div>
              <h2>Collaboration</h2>
              <div className='dtt_width'>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Invite users to shared folders</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Get detailed stats for your links</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
              </div>
            </div>
            <div className='collapse_contents'>
              <div className='collapse_img'>
                <img src="images/homepage/collaps_1.png" alt="Brand 1" />
              </div>
              <h2>Collaboration</h2>
              <div className='dtt_width'>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Invite users to shared folders</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Get detailed stats for your links</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
                <div className='dot_img'>
                  <img src="images/homepage/dots_img.png" alt="Brand 1" />
                  <p>Share links and File requests</p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section>

      {/* End section */}
    </>
  )
}

function Accounts() {
  return (
    <>
      {/* accont_section */}

      <section className='account_section'>
        <div className='landing-container'>
          <div className='row justify-content-center'>
            <div className='col-lg-6'>
              <div className='account_contents'>
                <div className='confirm_img'>
                  <img src="images/homepage/confirm_img.png" alt="Brand 1" />
                </div>
                <div className='account_contents'>
                  <h2 data-aos="fade-right">14 days money back guarantee!</h2>
                  <h2 data-aos="fade-left">Secure 256-bit SSL Encrypted payment</h2>
                </div>
                <div className='account_img'>
                  <img src="images/homepage/bank_img_1.png" data-aos="zoom-in" alt="image" />
                  <img src="images/homepage/bank_img_2.png" data-aos="zoom-in" alt="image" />
                  <img src="images/homepage/bank_img_3.png" data-aos="zoom-in" alt="image" />
                  <img src="images/homepage/bank_img_4.png" data-aos="zoom-in" alt="image" />
                  <img src="images/homepage/bank_img_5.png" data-aos="zoom-in" alt="image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* End section */}
    </>
  )
}

function ContactSection() {
  return (
    <div className="my-20 p-24 text-center md:my-80">
      <ForumIcon size="xl" className="text-muted" />
      <div className="my-8 md:text-lg">
        <Trans message="Do you have any questions about PRO accounts?" />
      </div>
      <div className="mb-24 mt-20 text-sm md:mt-0 md:text-base">
        <Trans message="Our support team will be happy to assist you." />
      </div>
      <Button variant="flat" color="primary" elementType={Link} to="/contact">
        <Trans message="Contact us" />
      </Button>
    </div>
  );
}
